import store from '../store';
import { pushLiveTicket } from '../store/tickets/actions';
import { generateTicket } from '../fixtures/live_ticket';

export function runLiveTicketTest(options = {maxTickets: 10}) {
  let i = 10000;
  const max = i + options.maxTickets;
  const intrId = setInterval(() => {
    if (i >= max) {
      return clearInterval(intrId);
    } 
    newLiveTicket(i++);
  }, 1500);
}

function newLiveTicket(id) {
  store.dispatch(
    pushLiveTicket(
      generateTicket(id)
    )
  )
}